export default __webpack_public_path__ + "static/media/yesno.c6bf039b.png";